// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import PutFeedbackRequestModel from '../../model/put-feedback-request-model';
import PutFeedbackRequestDTO from '../dto/put-feedback-request-dto';
import dtoSchema from '../schemas/put-feedback-request-schema';

export default abstract class PutFeedbackRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<PutFeedbackRequestDTO>) {
    super();
    if (data) {
      this.companyId = data.companyId;
      this.eventRating = data.eventRating;
      this.reparticipationRating = data.reparticipationRating;
      this.youthVisitorsCount = data.youthVisitorsCount;
      this.adultVisitorsCount = data.adultVisitorsCount ?? undefined;
      this.remark = data.remark ?? undefined;
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  companyId?: number;
  /**
  * @type {int32}
  */
  eventRating?: 1 | 2 | 3; // EventRatingDTO
  /**
  * @type {int32}
  */
  reparticipationRating?: 1 | 2 | 3; // ReparticipationRatingDTO
  /**
  * @type {int32}
  */
  youthVisitorsCount?: number;
  /**
  * @type {int32}
  */
  adultVisitorsCount?: number;
  /**
  */
  remark?: string;
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<PutFeedbackRequestDTO>): PutFeedbackRequestModel;
  static toModel(dto: DeepPartial<PutFeedbackRequestDTO> | undefined | null): PutFeedbackRequestModel | undefined;
  static toModel(dto: DeepPartial<PutFeedbackRequestDTO> | undefined | null): PutFeedbackRequestModel | undefined {
    return dto ? new PutFeedbackRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<PutFeedbackRequestModel> | PutFeedbackRequestModel): PutFeedbackRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      companyId: unwrapped.companyId,
      eventRating: unwrapped.eventRating,
      reparticipationRating: unwrapped.reparticipationRating,
      youthVisitorsCount: unwrapped.youthVisitorsCount,
      adultVisitorsCount: unwrapped.adultVisitorsCount,
      remark: unwrapped.remark,
      id: unwrapped.id,
    } as PutFeedbackRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for PutFeedbackRequestModel, can not map to PutFeedbackRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
